import FetchDataPlugin from './plugins/FetchDataPlugin';
import IndexPlugin from "@/core/work-components/we-select-person/indexPlugin.js";
export default {
  name: 'WeSelectPerson',
  FetchDataPlugin,
  IndexPlugin,

  data() {
    return {};
  },

  methods: {
    async openDialog() {
      this.$emit('on-open-dialog');
    }

  }
};